export const SCREENS = {
  LOADING: "loading",
  INIT: "init",
  DIAL_START: "dial_start",
  VIDEO: "video",
  GAME: "game",
  DIAL_END: "dial_end",
  MAIL: "mail",
  PARTAGE: "partage",
  DIAL_END2: "dial_end2",
  JAUGE: "jauge",
  RGPD: "rgpd",
  ORIENTATION: "orientation"
}